
import { identity, pipe } from 'ramda';
import { withPropsCurry } from '#utils';
import {
  CustomAutocomplete,
  CustomCheckbox,
  CustomInput,
  CustomSelect,
} from '../CustomInput';
import { TextArea } from '../TextArea';
import withFormikWrapper from './withFormikWrapper';


export const FormikAutocomplete = pipe(
  withFormikWrapper,
  withPropsCurry({ modifyOnChange: identity })
)(CustomAutocomplete);
export const FormikCheckbox = withFormikWrapper(CustomCheckbox);
export const FormikInput = pipe(withFormikWrapper, withPropsCurry({ inherit: true }))(CustomInput);
export const FormikSelect = withFormikWrapper(CustomSelect);
export const FormikTextArea = withFormikWrapper(TextArea);
